<template>
  <Layout class="bg-s-50" :without-footer="true" :without-content-class="true">
    <slot class="flex-grow" />
  </Layout>
</template>
<script setup lang="ts">
/** components */
import Layout from '~/components/TheLayout.vue'
</script>
